import type { FaireProductEntity } from "../../entity_types/product";

export const p_3egli7abrl: FaireProductEntity = {
  token: "p_3egli7abrl",
  type: "product",
  name: "Kids Relief 0-12 years, Pain & Fever Oral Liquid, 25 mL",
  brandToken: "b_7btl61xote",
  brandName: "homeolab International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/468db5f397ff01c319d73c3dbfbaeb14616b805b7082e1d0cb3d83c7d291e6e2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52b97c44ddcc4169d08013f07810aa066b809691af2ba60fd7838f6c24a20949.jpeg",
    "https://cdn.faire.com/fastly/2568488bc3ee02b56e34766db9bbccc9940ca375056851a2c1da508e93308bc0.jpeg",
    "https://cdn.faire.com/fastly/bcf35273813fc0b9e83c8d44e3a2ace2502e929ec872bd1d6053983651c635fd.jpeg",
    "https://cdn.faire.com/fastly/e8af13ceb848a69e40a5c04b367c67a398f28fd193d153b86266c5171a295d20.jpeg",
  ],
  priceDollars: 8.3,
  description:
    "When your child is suffering from a fever and the aches and pains that are often associated with a headache, sore throat, toothache, the common cold or the flu, reach for Kids Relief Pain & Fever. As you well know, there are a limited number of natural options, if any, that are available when it comes to giving your child relief from these symptoms. Our formula provides fast-acting, effective relief without the addition of Acetaminophen, dyes or sugars. Your kids will love the great-tasting cherry flavor and you will love our easy to administer Oral Liquid.\n\nSafe-Our Pain & Fever oral liquid there are no Side Effects, (No drug interactions), Gluten-free, Dye-free and Sugar-free.\nThis homoeopathic medicine helps relieve symptoms associated with pain & fever: Relieve pain & fever, relieve sore throat and headache.\nOur pain & fever oral liquid comes in a great-tasting raspberry flavor. Our gas & colic oral liquid offers up to 30-50 individual doses per bottle depending on your child's age",
  tags: [],
  msrpDollars: 13.84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:41.384Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
